"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkContext = void 0;
const react_1 = require("react");
const defaultState = {
    bookmarkGroups: [],
    setBookmarkGroups: () => null,
    addGroup: () => null,
    editGroup: () => null,
    removeGroup: () => null,
    addBookmark: () => null,
    editBookmark: () => null,
    removeBookmark: () => null,
};
exports.BookmarkContext = (0, react_1.createContext)(defaultState);
